module.exports = __webpack_public_path__ + "img/aqtobe3.45770fb6.jpg";